import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import ProtectedRoute from './components/ProtectedRoute';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';
import Dashboard from './pages/Dashboard';
import Menus from './pages/Menus';
import Categories from './pages/Categories';
import Dishes from './pages/Dishes';
import AddItem from './pages/AddItem';
import Settings from './pages/Settings';
import Login from './pages/Login';
import PublicMenu from './pages/PublicMenu';
import ModernMenu from './pages/ModernMenu';
import DishDetailPage from './pages/DishDetailPage';
import './index.css';

// Force light theme on app startup
document.body.setAttribute('data-theme', 'light');
localStorage.setItem('theme', 'light');

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <LanguageProvider>
        <Routes>
          {/* Modern Premium Menu Routes */}
          <Route path="/modern-menu" element={<ModernMenu />} />
          <Route path="/dish/:dishId" element={<DishDetailPage />} />
          
          {/* Legacy Public Menu Routes */}
          <Route path="/menu" element={<PublicMenu />} />
          <Route path="/public-menu" element={<PublicMenu />} />
          
          {/* Admin Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={
            <ProtectedRoute>
              <div className="app-container">
                <Sidebar />
                <div className="main-content">
                  <Navbar />
                  <div className="content">
                    <Dashboard />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          } />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute>
              <div className="app-container">
                <Sidebar />
                <div className="main-content">
                  <Navbar />
                  <div className="content">
                    <Dashboard />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          } />
          <Route path="/admin/menus" element={
            <ProtectedRoute>
              <div className="app-container">
                <Sidebar />
                <div className="main-content">
                  <Navbar />
                  <div className="content">
                    <Menus />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          } />
          <Route path="/admin/categories" element={
            <ProtectedRoute>
              <div className="app-container">
                <Sidebar />
                <div className="main-content">
                  <Navbar />
                  <div className="content">
                    <Categories />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          } />
          <Route path="/admin/dishes" element={
            <ProtectedRoute>
              <div className="app-container">
                <Sidebar />
                <div className="main-content">
                  <Navbar />
                  <div className="content">
                    <Dishes />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          } />
          <Route path="/admin/add-item" element={
            <ProtectedRoute>
              <div className="app-container">
                <Sidebar />
                <div className="main-content">
                  <Navbar />
                  <div className="content">
                    <AddItem />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          } />
          
          <Route path="/admin/settings" element={
            <ProtectedRoute>
              <div className="app-container">
                <Sidebar />
                <div className="main-content">
                  <Navbar />
                  <div className="content">
                    <Settings />
                  </div>
                </div>
              </div>
            </ProtectedRoute>
          } />
          
          {/* Redirect old routes to new admin routes */}
          <Route path="/" element={<Navigate to="/menu" replace />} />
          <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="/menus" element={<Navigate to="/admin/menus" replace />} />
          <Route path="/categories" element={<Navigate to="/admin/categories" replace />} />
          <Route path="/dishes" element={<Navigate to="/admin/dishes" replace />} />
          <Route path="/add-item" element={<Navigate to="/admin/add-item" replace />} />
          <Route path="/settings" element={<Navigate to="/admin/settings" replace />} />
        </Routes>
        </LanguageProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;